import React from "react";

import {AntdTable} from "../../components/custom/AntdTable";
import {BillOfMaterial} from "../../variants";

export const createIHLink = (operator, material) => (
	<a target="_blank" rel="noopener noreferrer" href={`/data?operator=${operator}&material=${material}`}>
		{material}
	</a>
);

export function BomDataTab({equipment}) {
	return (
		<AntdTable
			tableSize={"small"}
			scroll={300}
			data={BillOfMaterial.getRows(equipment)}
			columns={BillOfMaterial.getColumns(equipment)}
		/>
	);
}
